module.exports = __webpack_public_path__ + "img/b6-1.ebb50e9.png";